import { FC } from 'react'
import type { IconProps } from '../../types'

const Request: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1Z'
      fill='#3B42A5'
      stroke='white'
      strokeWidth='2'
    />
    <path
      d='M12.0002 8.25C12.6906 8.25 13.2502 7.69036 13.2502 7C13.2502 6.30964 12.6906 5.75 12.0002 5.75C11.3099 5.75 10.7502 6.30964 10.7502 7C10.7502 7.69036 11.3099 8.25 12.0002 8.25Z'
      fill='white'
    />
    <path
      d='M12.0002 18.25C12.6906 18.25 13.2502 17.6904 13.2502 17V10.75C13.2502 10.0596 12.6906 9.5 12.0002 9.5C11.3099 9.5 10.7502 10.0596 10.7502 10.75V17C10.7502 17.6904 11.3099 18.25 12.0002 18.25Z'
      fill='white'
    />
  </svg>
)

export default Request
